import { ValidatorDetail } from "@/features/treasury/treasury";

export default function TreasuryStakingValidatorPage() {
  return <ValidatorDetail />;
}
